import { createContext } from 'react';

import type { Orientation } from '../../../../../core/types/orientation.js';
import { ORIENTATION } from '../types/constants.js';

export const ChartLayoutOrientationContext = createContext<{
  orientation: Orientation;
}>({
  orientation: ORIENTATION.Vertical,
});

ChartLayoutOrientationContext['displayName'] = 'ChartLayoutOrientationContext';
